module.exports = __webpack_public_path__ + "website/img/tab4.00a58657.png";